import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { Role } from '../interfaces/rolesEnum'

export interface Profile {
  id: string
  name: string
  email: string
  role: keyof typeof Role
  subrole?: keyof typeof Role
  avatar_url?: string,
  manager_of_promoters_company_id?: string
  promoter_of_company_id?: string
  terms_acceptance: {
    id: string
    accepted_at: Date | string | null
    terms: {
      version: string
    }
  }[]
  created_at: Date | string | null
  updated_at: Date | string | null
}

interface AuthContextReducer {
  isAuthenticated: boolean | null
  profile: Profile | null
}

const initialState: AuthContextReducer = {
  isAuthenticated: null,
  profile: null,
}

const authContextSlice = createSlice({
  name: 'authContext',
  initialState,
  reducers: {
    setIsAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload
    },
    setProfile: (state, action: PayloadAction<Profile | null>) => {
      if (action.payload) {
        const formatDates: Profile = {
          ...action.payload,
          created_at: action.payload.created_at
            ? new Date(action.payload.created_at)
            : null,
          updated_at: action.payload.updated_at
            ? new Date(action.payload.updated_at)
            : null,
        }
        state.profile = formatDates
      } else {
        state.profile = null
      }
    },
  },
})

export const { setIsAuthenticated, setProfile } = authContextSlice.actions

export default authContextSlice.reducer
